// extracted by mini-css-extract-plugin
export default {"EditionAvatar":"EditionAvatar_EditionAvatar__bfHHw","BoutonChanger":"EditionAvatar_BoutonChanger__mEcbD"};